//#region Imports
import { useState } from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';

import { GlobalVariables } from '../../../../globalVar';
import customAxios from '../../../../utils/customAxios';
import { getToast } from '../../../../utils/toastConfig';
//#endregion

export const CreateFailureTypeModal = ({
  showModal,
  setShowModal,
  refreshData,
}) => {
  const [isLoading, setIsLoading] = useState(false); // State for tracking loading state
  const [newFailureType, setNewFailureType] = useState({
    name: '',
    description: '',
  }); // State for new region data

  /**
   * Resets the fields in the form to their initial state.
   */
  const handleResetFields = () => {
    setNewFailureType({ name: '', description: '' });
  };

  /**
   * Closes the modal and resets the form fields.
   */
  const handleClose = () => {
    setShowModal(false);
    handleResetFields();
    refreshData(); // Refresh failure types data
  };

  /**
   * Handles the form submission to create a new failure type.
   * @param {Event} e - The form submission event.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const endpoint = `${GlobalVariables.getURL()}failure-types/create`;

    try {
      const response = await customAxios.post(endpoint, newFailureType, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.status === 200) {
        getToast({
          status: 'success',
          title: 'Tipo de servicio creado exitosamente',
        }); // Show success message
        handleClose(); // Close modal and reset fields
      }
    } catch (error) {
      console.error('Error creating failure type:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      }); // Show error message
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  return (
    <Dialog open={showModal} maxWidth='md' fullWidth onClose={handleClose}>
      <DialogTitle>
        <Typography className='inventory-movmodal-title'>
          Nuevo tipo de servicio
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 20,
          top: 20,
          width: 40,
          height: 40,
        }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </IconButton>
      <DialogContent dividers>
        <form id='new-region-form' onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Name Field */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                disabled={isLoading}
                label='Nombre'
                placeholder='Nombre...'
                type='text'
                value={newFailureType.name}
                onChange={(e) =>
                  setNewFailureType((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }))
                }
              />
            </Grid>
            {/* Description Field */}
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                disabled={isLoading}
                label='Descripción'
                placeholder='Descripción...'
                type='text'
                value={newFailureType.description}
                onChange={(e) =>
                  setNewFailureType((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          form='new-region-form'
          type='submit'
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size='2rem' />
          ) : (
            <Typography>Guardar</Typography>
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
